import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faArrowsAltH, faBars, faBusinessTime, faCalendarAlt, faCalendarPlus, faCaretDown, faChartArea, faChartBar, faChartLine, faChartPie, faCheckCircle, faCode, faCommentAlt, faDollarSign, faEllipsisV, faExchangeAlt, faExpandArrowsAlt, faFile, faFileCsv, faFlag, faFlagCheckered, faFunnelDollar, faGlassCheers, faHandHoldingUsd, faHistory, faLayerGroup, faMoneyBill, faMoneyBillWave, faMoneyCheckAlt, faPeopleArrows, faPercent, faPlaneDeparture, faQuestionCircle, faSitemap, faSkiingNordic, faSync, faTimes, faTools, faUserAstronaut, faUserClock, faUserGraduate, faUserNinja, faUsers, faUsersCog, faUtensils, faWallet, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
import Vue from "vue";
import App from "./App.vue";
import DateHandler from "./classes/dateHandler";
import vuetify from "./plugins/vuetify";
import router from "./router";
import authentication from "./store/authentication";
import store from "./store/store";
library.add(faSync, faChartPie, faMoneyCheckAlt, faPeopleArrows, faUsers, faGlassCheers, faFileCsv, faSitemap, faDollarSign, faEllipsisV, faCheckCircle, faUtensils, faHandHoldingUsd, faSkiingNordic, faFlag, faFlagCheckered, faMoneyBill, faMoneyBillWave, faWallet, faQuestionCircle, faHistory, faExpandArrowsAlt, faFunnelDollar, faPercent, faChartBar, faChartLine, faExchangeAlt, faCaretDown, faTimes, faBars, faFile, faCalendarAlt, faChartArea, faArrowsAltH, faCode, faTools, faPlaneDeparture, faCalendarPlus, faUserAstronaut, faUserGraduate, faUserClock, faUsersCog, faBusinessTime, faUserNinja, faLayerGroup, faCommentAlt);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("authentication", authentication);
dom.watch();
import ErrorHandler from "@/classes/errorHandler";
if (process.env.VUE_APP_SENTRY_ENV &&
    process.env.VUE_APP_SENTRY_ENV === "production") {
    console.log = () => { };
}
//@ts-ignore
import Adal from "vue-adal";
Vue.use(Adal, {
    config: {
        // 'common' (multi-tenant gateway) or Azure AD Tenant ID
        tenant: "geshdo.onmicrosoft.com",
        clientId: process.env.VUE_APP_AZURE_CLIENT_ID,
        redirectUri: window.location.origin,
        cacheLocation: "localStorage",
    },
    requireAuthOnInitialize: true,
});
console.log(process.env.NODE_ENV);
if (process.env.VUE_APP_SENTRY_ENV !== "local") {
    Sentry.init({
        Vue,
        environment: process.env.VUE_APP_SENTRY_ENV,
        dsn: "https://fd87c4764a94402d9fcef379fb6a237d@o612714.ingest.sentry.io/5770117",
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: Number(process.env.VUE_APP_SENTRY_TRACESSAMPLERATES),
    });
}
Vue.prototype.$dateHandler = new DateHandler();
Vue.config.productionTip = false;
// declare the eventbus in the app
window.eventBus = new Vue();
window.dateHandler = new DateHandler();
window.errorHandler = new ErrorHandler();
// For Jesper's sanity
if (process.env.VUE_APP_SENTRY_ENV &&
    process.env.VUE_APP_SENTRY_ENV !== "production") {
    window.document.title = `${process.env.VUE_APP_SENTRY_ENV.substr(0, 3).toUpperCase()} - ${window.document.title}`;
}
// unregister the service worker if it exists
if (window.navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
            registration.unregister();
        }
    });
}
new Vue({
    el: "#app",
    vuetify,
    router,
    store,
    render: (h) => h(App),
});
